// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"571":"d34dd677d5a9a5aa","1270":"f8572ed3a228ca82"}[chunkId] + ".css";
};